import { makeStyles } from '@mui/styles';

import { Colors } from 'styleguide-v2';

export const RowStyles = makeStyles({
  row: {
    width: '100%',
  },
  rowInner: {
    padding: '0.5rem',
    width: '100%',
  },
  rowEven: {
    backgroundColor: `${Colors.gray}33`,
    borderRadius: '0.5rem',
  },
  preferredIcon: {
    marginLeft: '-0.5rem',
  },
});
